import './index.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { queryClient } from './app/queryClient';
import { routes } from './app/routes';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './features/auth/AuthProvider';
import { HealthProvider } from './features/system/HealthProvider';
import { registerServiceWorker } from './pwa/register';

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing');

const router = createBrowserRouter(routes);

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <HealthProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </HealthProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// Installable app (PWA): the service worker only precaches the app shell.
registerServiceWorker(import.meta.env.PROD);
